"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePvs = exports.pvsData = exports.resultsDefinition = void 0;
const functions_1 = require("../functions");
const property_1 = require("@genesys/property");
// Every value CoilPro returns for this coil, under CoilPro's own names, so one vocabulary runs
// from the DLL through the schema to the translation key. Errors and warnings are comma-joined
// strings; a coil can calculate successfully and still warn, so an empty warnings cell is the
// only clean result.
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: "errors"
    },
    {
        sortNo: 20,
        propertyName: "warnings"
    },
    {
        sortNo: 30,
        propertyName: "airpressuredrop"
    },
    {
        sortNo: 40,
        propertyName: "airpressuredropdry"
    },
    {
        sortNo: 50,
        propertyName: "airtotalcapacity"
    },
    {
        sortNo: 60,
        propertyName: "temperatureout"
    },
    {
        sortNo: 70,
        propertyName: "humidityout"
    },
    {
        sortNo: 80,
        propertyName: "pressureout"
    },
    {
        sortNo: 90,
        propertyName: "flow"
    },
    {
        sortNo: 100,
        propertyName: "airvelocity"
    },
    {
        sortNo: 110,
        propertyName: "airstandardvelocity"
    },
    {
        sortNo: 120,
        propertyName: "connectionvelocity"
    },
    {
        sortNo: 130,
        propertyName: "condensedwater"
    },
    {
        sortNo: 140,
        propertyName: "sensibletotalcapacityratio"
    },
    {
        sortNo: 150,
        propertyName: "fluidpressuredrop"
    },
    {
        sortNo: 160,
        propertyName: "fluidtemperaturein"
    },
    {
        sortNo: 170,
        propertyName: "fluidtemperatureout"
    },
    {
        sortNo: 180,
        propertyName: "fluidvolumeflow"
    },
    {
        sortNo: 190,
        propertyName: "fluiddensity"
    },
    {
        sortNo: 200,
        propertyName: "fluidvelocity"
    },
    {
        sortNo: 210,
        propertyName: "reynoldsnumberfluid"
    },
    {
        sortNo: 220,
        propertyName: "wetratio"
    }
];
const pvsData = (result) => ({
    errors: result.errors,
    warnings: result.warnings,
    airpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airPressureDrop)),
    airpressuredropdry: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airPressureDropDry)),
    airtotalcapacity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airTotalCapacity)),
    temperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.temperatureOut)),
    humidityout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.humidityOut)),
    pressureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.pressureOut)),
    flow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.flow)),
    airvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airVelocity)),
    airstandardvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airStandardVelocity)),
    connectionvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.connectionVelocity)),
    condensedwater: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.condensedWater)),
    sensibletotalcapacityratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.sensibleTotalCapacityRatio)),
    fluidpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidPressureDrop)),
    fluidtemperaturein: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidTemperatureIn)),
    fluidtemperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidTemperatureOut)),
    fluidvolumeflow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidVolumeFlow)),
    fluiddensity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidDensity)),
    fluidvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.fluidVelocity)),
    reynoldsnumberfluid: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.reynoldsNumberFluid)),
    wetratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.wetRatio)),
});
exports.pvsData = pvsData;
const makePvs = (result) => (0, functions_1.collectResults)((0, exports.pvsData)(result));
exports.makePvs = makePvs;
//# sourceMappingURL=result-definition.js.map